import { useLocalization } from "@fluent/react";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const FrequencyFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const label = l10n.getString(FILTER_CONFIG[FilterChips.FREQUENCY].labelKey);

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.FREQUENCY}
      filterOptions={FILTER_CONFIG[FilterChips.FREQUENCY].options}
      label={label}
    />
  );
};

export default FrequencyFilter;
